import Event from '../../core/Event';

export default class SendForgotPasswordEmailRequested extends Event {
    public static type = 'SendForgotPasswordEmailRequested';

    constructor(public readonly email: string) {
        super(SendForgotPasswordEmailRequested.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/user/events/SendForgotPasswordEmailRequested.ts